import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { ButtonLink } from '../components/ui/ButtonLink';
import { ClosingInvitation } from '../components/sections/ClosingInvitation';
import { workspaces } from '../data/workspaces';
import { DEMO_CENTER_URL } from '../data/navigation';
export function Demos() {
  return <>
      <section className="pb-14 pt-14 md:pt-20" data-id="element-644" data-mp="dqpmp6z88pxu">
        <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 md:px-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-645" data-mp="drhee6ppe3iu">
          <div className="max-w-2xl" data-id="element-646" data-mp="8picz2dixgoj">
            <h1 className="text-balance text-4xl font-semibold tracking-display sm:text-5xl md:text-6xl" data-id="element-647" data-mp="nh10rmcmkfig">Try Noetivra yourself.</h1>
            <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-648" data-mp="ip0w5glm0yfj">
              Seven interactive demonstrations, one for each field. Each uses sample data, so you can explore every
              workspace and complete real workflows freely.
            </p>
          </div>
          <ButtonLink href={DEMO_CENTER_URL} icon="external" className="self-start lg:self-auto" data-id="element-649" data-mp="1wmk5p3bhurfe">
            Open the Demo Center
          </ButtonLink>
        </div>
      </section>

      <section className="pb-24 md:pb-32" data-id="element-650" data-mp="25ecdf694vmga">
        <div className="mx-auto grid max-w-7xl gap-4 px-5 md:grid-cols-2 md:px-8 xl:grid-cols-3" data-id="element-651" data-mp="25em3suy3bvmi">
          {workspaces.map(w => {
          const Icon = w.icon;
          return <article key={w.slug} className="glass flex flex-col rounded-[28px] p-7" data-id="element-652" data-mp="1do7t17ldizf2">
                <div className="flex items-center justify-between" data-id="element-653" data-mp="1hpj9onm9sab4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-accent shadow-sm ring-1 ring-ink/[0.05]" data-id="element-654" data-mp="1mnujiyckektc">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-655" data-mp="1ro8w8tp42ixp" />
                  </span>
                  <span className="rounded-full bg-ok-soft px-2.5 py-0.5 text-[11px] font-medium text-ok-ink" data-id="element-656" data-mp="2y1yfga2pqj11">Sample data</span>
                </div>
                <h2 className="mt-6 text-xl font-semibold tracking-tight" data-id="element-657" data-mp="2ddp1l55suhzn">{w.name}</h2>
                <p className="mt-0.5 text-sm text-ink-muted" data-id="element-658" data-mp="2dfiays7srgbc">{w.demo.name}</p>
                <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-659" data-mp="28ech2r2ehn08">
                  <span className="font-medium text-ink" data-id="element-660" data-mp="2nak19rdt6ofi">Try it: </span>
                  {w.demo.tryText}
                </p>
                <dl className="mt-5 space-y-3 border-t border-ink/[0.07] pt-5 text-[13px]" data-id="element-661" data-mp="2idjwrkwlxtqi">
                  <div data-id="element-662" data-mp="1unh5v84fitth">
                    <dt className="text-ink-muted" data-id="element-663" data-mp="1ukv1fhcu4ufh">Audience</dt>
                    <dd className="mt-0.5 font-medium" data-id="element-664" data-mp="1ppo1mkmos9vu">{w.audience.replace(/^For /, '')}</dd>
                  </div>
                  <div data-id="element-665" data-mp="24f3o3of6pt5q">
                    <dt className="text-ink-muted" data-id="element-666" data-mp="1zmakx4zd6svr">Workspaces</dt>
                    <dd className="mt-1.5 flex flex-wrap gap-1.5" data-id="element-667" data-mp="1zkzhx7dqtp5p">
                      {w.surfaces.map(s => <span key={s.name} className="rounded-full bg-white px-2.5 py-1 text-[12px] font-medium ring-1 ring-ink/[0.06]" data-id="element-668" data-mp="1bud758cctqs0">
                          {s.name}
                        </span>)}
                    </dd>
                  </div>
                </dl>
                <div className="mt-auto flex items-center justify-between gap-3 pt-7" data-id="element-669" data-mp="3ndruglfwgjpw">
                  <a href={w.demo.url} target="_blank" rel="noopener noreferrer" className="group inline-flex h-10 items-center gap-1.5 rounded-full bg-accent px-4 text-sm font-medium text-white transition-colors duration-150 hover:bg-accent-ink" data-id="element-670" data-mp="38olwf0ssszjl">
                    Launch demo
                    <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:-translate-y-px group-hover:translate-x-px" aria-hidden="true" data-id="element-671" data-mp="3sa045jbbvkpo" />
                    <span className="sr-only" data-id="element-672" data-mp="2gv3ce1nrehem">for {w.name} (opens in a new tab)</span>
                  </a>
                  <Link to={`/workspaces/${w.slug}`} className="text-sm font-medium text-ink-soft transition-colors duration-150 hover:text-ink" data-id="element-673" data-mp="2kxggklmuy79a">
                    About this workspace
                  </Link>
                </div>
              </article>;
        })}
        </div>
      </section>

      <ClosingInvitation title="Want a guided walkthrough?" body="We can tailor a demonstration to your organization, field, and workflow." primary={{
      label: 'Request a Demo',
      to: '/contact'
    }} data-id="element-674" data-mp="2rfkxu0roeg3s" />
    </>;
}